export const ROUTE = 'purchase/siteconfigurator/ROUTE';
export const route = () => ({ type: ROUTE });
